import type { CookieCategoryValue } from ".";
import getConsentedGroups from "./getConsentedGroups";

export let callbacks: Set<(consentedType: CookieCategoryValue[]) => void> = new Set();

// Runs on initial load and everytime there is a consent action taken
const onCookieConsent = (
	cookieId: CookieCategoryValue,
	onConsent: () => void,
	onDeny?: () => void
): () => void => {
	const wrappedCallback = (consentedTypes: CookieCategoryValue[]) => {
		const userConsented = consentedTypes.includes(cookieId);

		if (userConsented) {
			onConsent();
			return;
		}

		if (!userConsented && onDeny) {
			onDeny();
		}
	};

	// if already exists on page, run code now as well
	if (window.OnetrustActiveGroups) {
		wrappedCallback(getConsentedGroups());
	}

	callbacks.add(wrappedCallback);

	return () => {
		callbacks.delete(wrappedCallback);
		if (onDeny) {
			onDeny();
		}
	}
};

export default onCookieConsent;
